import EditPageSortableList from './EditPageSortableList';

export { EntityName } from './EditPageSortableItem';
export { EntityType } from './EditPageSortableItem';
export { EntityDesciption } from './EditPageSortableItem';
export default EditPageSortableList;
